import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ConsumptionIconPipe,
  ConsumptionNamePipe,
  ConsumptionUnitType,
  getSelectedConsumptionForMeter,
  IConsumption,
  IConsumptionInfoItem,
  IConsumptionState,
  NameDisplayMode,
} from '@resident-nx/shared';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, DatePipe, DecimalPipe } from '@angular/common';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-consumption-chart-additional-info',
  templateUrl: 'consumption-chart-additional-info.component.html',
  styleUrls: ['consumption-chart-additional-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IconWebComponent,
    AsyncPipe,
    DecimalPipe,
    DatePipe,
    TranslateModule,
    ConsumptionIconPipe,
    ConsumptionNamePipe,
  ],
})
export class ConsumptionChartAdditionalInfoWebComponent implements OnInit {
  @Input() meter: IConsumptionInfoItem;
  public iconColor = 'var(--color-text-primary, #3486ef)';

  public selectedConsumption$: Observable<IConsumption>;
  public showZnNumber: boolean;

  constructor(private store: Store<IConsumptionState>) {}

  ngOnInit() {
    this.selectedConsumption$ = this.store.select(
      getSelectedConsumptionForMeter(this.meter.deviceId)
    );

    /***
     todo: refactor on consumption rebuild -> only if uvi api cause the ZN doesn't make any sense to the user it's only
     a database reference
     */
    this.showZnNumber = this.meter.deviceId.split('+').length === 1;
  }

  protected readonly NameDisplayMode = NameDisplayMode;
  protected readonly ConsumptionUnitType = ConsumptionUnitType;
}
